<template>
  <div class="image-preloader">
    <div v-if="windowWidth > 960">
      <img 
        v-for="(image, i) in images"
        :key="i"
        :src="require(`@/assets/img/${image.name}-desktop.${image.type}`)"
        @load="handleLoad"
        @error="handleLoad"
      >
    </div>
    <div v-else>
      <img 
        v-for="(image, i) in images"
        :key="i"
        :src="require(`@/assets/img/${image.name}.${image.type}`)"
        @load="handleLoad"
        @error="handleLoad"
      >
    </div>
    <!-- <img 
      :src="require('@/assets/1024/texture-brick-1-top.jpg')"
      @load="handleLoad"
      @error="handleLoad"
    >
    <img 
      :src="require('@/assets/1024/texture-brick-2-top.jpg')"
      @load="handleLoad"
      @error="handleLoad"
    >
    <img 
      :src="require('@/assets/1024/texture-brick-3-top.jpg')"
      @load="handleLoad"
      @error="handleLoad"
    > -->
  </div>
</template>

<script>
  export default {
    name: 'ImagePreloader',

    data() {
      return {
        windowWidth: window.innerWidth,
        images: [
          { name: 'curtain-back', type: 'jpg' },
          { name: 'curtain-left', type: 'png' },
          { name: 'curtain-right', type: 'png' },
          { name: 'walls-top', type: 'png' },
          { name: 'walls-left', type: 'png' },
          { name: 'walls-right', type: 'png' },
        ],
        imgLoaded: 0,
        interval: null,
      }
    },

    mounted() {

    },

    methods: {

      handleLoad(){
        this.imgLoaded++;
        if(this.imgLoaded === this.images.length) {
          this.interval = setInterval(this.checkBrickFont, 300);
          setTimeout( () => {
            clearInterval(this.interval);
          }, 5000);
        }
      },

      checkBrickFont() {
        if(document.fonts.check("20px " + "rollerscript-smooth")){
          clearInterval(this.interval);
          this.$emit('isReady', true);
          return true;
        } else {
          return false;
        }
      }

    }
  }
</script>